var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more"},[_c('img',{attrs:{"src":require("@/assets/images/icons/more.svg"),"width":_vm.size}})])
}
var staticRenderFns = []

export { render, staticRenderFns }